import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import reg from '@/reg'
import * as _ from 'lodash';

// another vue
import groupList from '../../group/group.List.i18n'
import logLoginList from '../../../Log/login/login.User.List.i18n'
import logActionList from '../../../Log/action/action.User.List.i18n'

//restful api
import { user as manager, group } from '@/service/api/manager'
import { auth } from '@/service'

const default_model = () => ({
  is_verified: true, group : { service : "Basic" }, permissions: 'User', username : '', new_password : '', new_password_repeat : '',
});

export default {
  props: ['user_id'],
  components: {
    logActionList,
    cSwitch,
    vSelect,
    groupList,
    logLoginList,
  },
  watch : {
    '$route' (to, from) { console.log("from : ", from);  this.get(to.params); },
  },
  data : () => ({
    codes,
    confirm: false,
    add: false,
    lock: true,
    group_list: undefined,
    model : default_model(),
    old_username : '',
    allowed: false,

    // group info side
    chainGroup : false,
    syncGroup : false,
    loadGroup : false,
    region : {
      language : codes.language_default,
      country : codes.country_default,
      timezone : codes.timezone_default
    },
    password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
    origin : { timezone : "", country : "", language : "" },
    
  }),
  computed: {
    border() { return !reg.email.test(this.model.username) || this.model.title == '' ? 'danger' : 'success'},
    TextLength() { return this.model.username.length > 0 ? true : false; },
    profile() { return auth.profile; }
  },
  methods: {
    //mail reset
    async send_password_reset_mail() {
      let rs = await manager.passwordUser({ id : this.model.id });
      return rs.is_error ? this.$toastr.e("Sending Password Reset Mail", "failed") : this.$toastr.s("Password Reset Mail", "Sented");
    },
    //ip reset
    async send_ip_reset_mail() {
      let rs = await manager.ipUser({ id : this.model.id });
      return rs.is_error ? this.$toastr.e("Sending IP ACL Reset Mail", "failed") : this.$toastr.s("IP ACL Reset Mail", "Sented");
    },
    auto_set_nickname ($event, username) { this.model.nickname = username.indexOf("@") > -1 ? username.split("@")[0] : username; },
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.new_password && reg.reg_number.test(this.model.new_password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.new_password && reg.reg_alphabat_upper.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.new_password && reg.reg_alphabat_lower.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.new_password && reg.reg_spacial.test(this.model.new_password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.new_password && this.model.new_password.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    cancel() { this.lock = true; this.$router.push({ name: 'user', params: { id: this.model.id }}); this.$emit('refresh'); },
    edit() { this.$router.push({ name: 'user', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        let rs = await manager.deleteUser({ id : this.model.id });
        if(!rs.error) {
          this.$emit('refresh'); this.$toastr.s('Removed Success.'); this.list();
        } else {
          this.$emit('refresh'); this.$toastr.s('delete', "failed"); this.list();
        }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    list() { this.$router.push({ name: 'user'}); this.$emit('refresh'); },
    setGroup(item) {
      // console.log("item : ",item)
      this.model.group = item;
      if(!item.service) { this.model.group.service = this.model.service } // set default
      this.chainGroup = false;
      this.syncGroup = true;
    },
    groupList() { this.$router.push({ name: 'group', params : { id : this.model.group_id }}); this.$emit('refresh'); },
    refresh() {
      this.$emit('refresh');
      console.log("refresh", this.$route.name, new Date());
    },
    async save() {
      let model;

      // check validation
      try {
        if(!(this.model.permissions || '').trim()) { return this.$toastr.e('Permission Required.'); }
        if(!(this.model.username || '').trim()) { return this.$toastr.e('Username(ID) Required.'); }
        if(!(this.model.nickname || '').trim()) { return this.$toastr.e('Nickname Required.'); }
        // if(!this.model.id && !this.model.new_password) { return this.$toastr.e('Password Required.'); }
        if(this.model.new_password && this.model.new_password != this.model.new_password_repeat) { return this.$toastr.e('Password and password repeat do not match'); }
        if(this.model.new_password) {
          var rs = this.password_policy('all')
          if(rs.is_error) {
            var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
            return this.$toastr.e(`Please check password policy [${msg}]`);
          }
        }
      } catch (e) { console.log(e); return this.$toastr.e('check validation failed'); }

      // build data for sending
      model = Object.assign({}, this.model, { permissions : codes.permissions_user_value[this.model.permissions] })
      if(model.new_password) { model.new_password = forge.sha256.create().update(model.new_password).digest().toHex(); }
      if(model.group && model.group.id) { model.group_id = model.group.id; }
      if(this.model.allow_ip_list) {
        model.allow_ip = _.uniq(_.compact(this.model.allow_ip_list.replace(/,/gm, '').split("\n")));
        // b-form-textarea has bug, can not bind model so rirect update
        this.model.allow_ip_list = _.join(model.allow_ip, '\n')
        this.$refs.allow_ip_list.localValue = _.join(model.allow_ip, '\n')
      } else { model.allow_ip = "" }

      try {
        let check_id = '';
        check_id = this.model.id ? `${await manager.updateUser(model)}` : `${await manager.insertUser(model)}`;

        let rs = check_id;

        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name); //this.cancel();
          this.list();
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e ? e.data ? e.data : e.statusText : e.statusText); this.list();}
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      this.model = default_model()
      if(tag == 'group') {
        try {
          console.log('User.detail.vue', 'group item', id);
          this.loadGroup = true;

          let rs = await group.detailGroup({ id : this.user_id ? this.user_id : id })

          this.model.group = Object.assign({ group: {} }, this.model.group, rs.body)
          this.model.group_id = this.model.group.id;
          this.loadGroup = false;

        } catch(e) { this.$toastr.e(e ? e.data ? e.data : e.statusText : e.statusText), this.list() }
      }
      if(id === 'add' || tag == 'group') { this.add = true; this.lock = false; this.model.is_alive = true; }
      else {
        // this.model.id = Number(this.user_id ? this.user_id : id);
        console.log('User.detail.vue', 'load item', id);
        try{
          this.add = false;
          this.lock = (tag != 'edit');

          let rs = await manager.detailUser({ id : this.user_id ? this.user_id : id })
          this.model = Object.assign({ group: {} }, this.model, rs.body)

          let is_done_country = false;
          codes.country.forEach(r => { if(is_done_country) { return; } else if(r.value == this.model.group.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

          let is_done_language = false;
          codes.language.forEach(r => { if(is_done_language) { return; } else if(r.value == this.model.group.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(r.value == this.model.group.timezone) { this.region.timezone = r; is_done_timezone = true } });

          this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")

        } catch(e) { this.$toastr.e(e ? e.data ? e.data : e.statusText : e.statusText), this.list() }
      }
    }
  },
  created() { console.log('User_Detail.vue', 'created'); }, //this.$root.$on("select", this.set)
  destroyed() { console.log('User_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('User_Detail.vue', 'mounted');
    this.get(this.$route.params);
    this.$root.$on('select', this.setGroup);
    this.refresh()
  },
}